import React, { useEffect } from 'react';
import { Card,  CardBody,  CardTitle } from 'reactstrap';
import {connect, useSelector} from "react-redux";


// components
import PromotionFilters from "./_filters";

// labels
import {ARE_YOU_SHURE_TITLE, CONFIRM_SYNC, CONFIRM_YES, error, LIST, NO} from "../../../components/i18n/i18n";

// services
import { promotionService } from "../../../jwt/_services/promotions/promotionService";

// actions
import {setFilter, setTableParams, setLoading, setViewMode, setForm, setItem} from "../../../redux/actions/generics/IndexedActions";
import {genericIndexedActions} from "../../../redux/actions/generics/GenericIndexedActions";


import {ModalFormContainer} from "../../../components/confirmAlert/ModalFormContainer";
import PromotionControllerForm from "./_form";
import {getStateByPath} from "../../../redux/selectors";
import {DragDropList} from "../../../components/draggableList/DragDropList";
import Pagination from "rc-pagination";
import PromotionItem from "./_listItem";
import {GenericButton} from "../../../components/buttons/customButtons";
import {productPriceService} from "../../../jwt/_services/promotions/productPriceService";
import {showToastCustom} from "../../../components/toast/customToast";
import {confirmAlert} from "react-confirm-alert";
import PromotionProduct from "./productSection/PromotionProduct";


const PromotionControllerList = (props) => {
    const componentState = useSelector(state => getStateByPath(state, props.path));

    const { path } = componentState;
    const { app, pageSize, pageIndex, totalSize, listDomainObjects, filter } = componentState?.data;

    useEffect(() => {
        if (!app?.id || filter)
            return;

        props.setFilter(path , {
            onlyRegistered: true,
            fbDataBase: { id: app?.fbDataBase.id },
            item: { status: true }
        });
    }, [ app ]);

    useEffect(() => {
        if(!filter)
            return

        genericIndexedActions.search(path, promotionService, pageIndex, 12, filter)
    }, [pageIndex, filter ]);

    const handleTableChange = (_page) => {
        let currentIndex = (_page - 1) * pageSize;
        props.setTableParams(path, 12, currentIndex, totalSize, currentIndex );
    };

    const createItem = () => {
        props.setItem(path, null);
        props.setForm(path);
        ModalFormContainer( PromotionControllerForm, { path } )
    }

    const editItem = (data) => {
        props.setForm(path, true, false, false);
        props.setItem(path, data);

        ModalFormContainer(PromotionControllerForm, { path, data, Form: PromotionControllerForm })
    }

    const editProducts = (data) => {
        props.setForm(path, true, false, false);
        props.setItem(path, data);

        ModalFormContainer(PromotionProduct, { path, data, Form: PromotionProduct })
    }

    const confirmSyncSinglePromotionPrices = (data)=> confirmAlert({
        closeOnEscape: true,
        closeOnClickOutside: true,
        customUI: ({onClose}) => <div className='custom-ui'>
            <h1>{ARE_YOU_SHURE_TITLE}</h1>
            <p>{CONFIRM_SYNC}</p>
            <button onClick={onClose}>{NO}</button>
            <button className={"btn-alert-delete"} onClick={() => {
                syncSinglePromotionPrices(data)
                onClose();
            }}>
                {CONFIRM_YES}
            </button>
        </div>
    });

    const syncSinglePromotionPrices = (data) => {
        const dataRequest = {
            id : data?.id
        }
        props.setLoading(path,true);
        productPriceService.syncSinglePromotionPrices(dataRequest)
            .then(_ => {
                props.setLoading(path,false);
            })
            .catch(errorMessage => {
                props.setLoading(path,false);
                showToastCustom(error, errorMessage);
            });
    }

    const onReorder = (reorderProps) => {
        // Crear una copia de listDomainObjects para evitar mutaciones directas
        let updatedListDomainObjects = [...listDomainObjects];
        let anyId = '' // Variable para guardar el id de cualquier ítem que haya cambiado de orden, necesitamos al menos un id real
        let dataRequest = {
            fbDataBase:  { id : app?.fbDataBase?.id },
            items: []
        }

        for (const reorderedItem of reorderProps.list) {
            // Validar si el ítem tiene un id (es decir, si existe en la base de datos)
            if (reorderedItem.id) {
                // Buscar el ítem en listDomainObjects
                let domainObject = updatedListDomainObjects.find(domainObject => domainObject.id === reorderedItem.id);

                if (domainObject && domainObject.showOrder !== reorderedItem.showOrder) {
                    anyId = domainObject.id
                    dataRequest.items.push({
                        id: domainObject.id,
                        showOrder: reorderedItem.showOrder
                    })
                }

            }
        }

        genericIndexedActions.update(path, promotionService, anyId, dataRequest)
    }

    const renderContent = (item, index) => {
        return (
            <PromotionItem
                item={item}
                index={index}
                onEdit={editItem}
                onEditProducts={editProducts}
                onUpdatePrices={confirmSyncSinglePromotionPrices}
            />
        )
    }

    return <Card>
        <CardTitle className="bg-light border-bottom p-3 mb-0">
            <i className="far fa-list-alt mr-2"> </i>{LIST}
            <div className="float-right">
                <GenericButton
                    style={'table'}
                    label={'Agregar'}
                    toolTip={'Agregar'}
                    icon={'fa-plus'}
                    permission={'add'}
                    onClick={createItem}
                />
            </div>
        </CardTitle>
        <CardBody className="">
            <PromotionFilters path={path}/>
            {
                listDomainObjects.length > 0 &&
                <DragDropList
                    items={listDomainObjects}
                    renderContent={renderContent}
                    onReorder={onReorder}
                    orientationHV={'ruby-text-container'} // CSS class para orientar los elementos horizontalmente
                />
            }
            <Pagination
                total={totalSize}
                shape="rounded"
                current={pageIndex}
                onChange={handleTableChange}
                pageSize={pageSize}
            />
        </CardBody>
    </Card>
}

const mapStateToProps = state => ({
})

const mapActionsToProps = ({
    setFilter,
    setTableParams,
    setViewMode,
    setForm,
    setItem,
    setLoading,
})
export default connect(mapStateToProps, mapActionsToProps)(PromotionControllerList)
